/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

import { ROUTES } from '../constants/routes'
import { getDataFactory } from '../functions/getDataFactory'
import { config } from '../functions/config'

import { store } from '../store.js'

const getDataProperty = getDataFactory({ fetch: window.fetch, apiEndPoint: config.propertyAPI })
const getDataAccount = getDataFactory({ fetch: window.fetch, apiEndPoint: config.accountAPI })
const getDataContract = getDataFactory({ fetch: window.fetch, apiEndPoint: config.contractAPI })
const getDataRenewal = getDataFactory({ fetch: window.fetch, apiEndPoint: config.renewalAPI })
const getDataPackage = getDataFactory({ fetch: window.fetch, apiEndPoint: config.packageAPI })
const getDataPromocode = getDataFactory({ fetch: window.fetch, apiEndPoint: config.promoCodeAPI })

export const UPDATE_PAGE = 'UPDATE_PAGE'
export const UPDATE_OFFLINE = 'UPDATE_OFFLINE'
export const UPDATE_DRAWER_STATE = 'UPDATE_DRAWER_STATE'
export const OPEN_SNACKBAR = 'OPEN_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const UPDATE_SELECTED_ITEM = 'UPDATE_SELECTED_ITEM'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const ADD_FIELD_OPTION = 'ADD_FIELD_OPTION'
export const CHANGE_HIDDEN_COLUMNS = 'CHANGE_HIDDEN_COLUMNS'
export const CHANGE_TABLE_ACTIVE_FLAG = 'CHANGE_TABLE_ACTIVE_FLAG'
export const ADD_RELATION_CLONE = 'ADD_RELATION_CLONE'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const ADD_WARNING_ITEM = 'ADD_WARNING_ITEM'
export const REMOVE_WARNING_ITEM = 'REMOVE_WARNING_ITEM'
export const ADD_EDITABLE_ITEM = 'ADD_EDITABLE_ITEM'
export const REMOVE_EDITABLE_ITEM = 'REMOVE_EDITABLE_ITEM'
export const ADD_EDITABLE_RENEWAL = 'ADD_EDITABLE_RENEWAL'
export const REMOVE_EDITABLE_RENEWAL = 'REMOVE_EDITABLE_RENEWAL'
export const UPDATE_LIST = 'UPDATE_LIST'
export const UPDATE_ITEM_IN_LIST = 'UPDATE_ITEM_IN_LIST'

export const navigate =
    (path, forceChange = false) =>
    (dispatch) => {
        // Extract the page name from path.
        let page = `/${ROUTES.LOGIN}`

        if (store.getState().app.loggedIn) {
            page = path || defaultPage
        }

        // Any other info you might want to extract from the path (like page type),
        // you can do here
        dispatch(loadPage(page))

        // Close the drawer - in case the *path* change came from a link in the drawer.
        dispatch(updateDrawerState(false))
        if (!forceChange) {
            removeNotificationOnPageChange(dispatch)
        }
    }

const removeNotificationOnPageChange = (dispatch) => {
    const notifications = store.getState().app.notifications
    if (!notifications) return
    const peristentNotifications = notifications.filter(
        (notification) => notification.persistOnPageChange
    )

    dispatch({
        type: SET_NOTIFICATIONS,
        notifications: peristentNotifications,
    })
}

const loadPage = (page) => (dispatch) => {
    let pageSelected = page

    let pageSplit = []
    let pageBase

    pageSplit = page.split('/')
    pageBase = `${pageSplit[1]}`
    const pageParam = pageSplit.length > 2 ? pageSplit[2] : null

    switch (pageBase) {
        // case ROUTES.LOGIN:
        //     import('../components/htPandoraLogin.js')
        //     break
        case ROUTES.HOME:
            import('../components/htPandoraHome.js')
            break
        case ROUTES.SEARCH:
            import('../components/htPandoraSearchPage.js')
            break
        case ROUTES.PROPERTIES:
        case ROUTES.PRODUCTS:
        case ROUTES.PRODUCT_PACKAGES:
        case ROUTES.ACCOUNTS:
        case ROUTES.CONTRACTS:
        case ROUTES.PRICEBOOKS:
        case ROUTES.PRICEBOOK_ENTRIES:
        case ROUTES.NOTES:
        case ROUTES.PROMO_CODES:
        case ROUTES.PROMO_CODE_TYPES:
        case ROUTES.PROMO_CODE_FAMILIES:
        case ROUTES.PRODUCT_TO_PROMOCODES:
        case ROUTES.PACKAGE_TO_PROMOCODES:
        case ROUTES.REFERRALS:
        case ROUTES.RENEWALS:
            import('../components/htPandoraListPage.js')
            break
        case ROUTES.PRODUCT_NEW:
        case ROUTES.PROPERTY_NEW:
        case ROUTES.ACCOUNT_NEW:
        case ROUTES.CONTRACT_NEW:
        case ROUTES.ACCOUNT_TO_PROPERTY_NEW:
        case ROUTES.PRODUCT_PACKAGE_NEW:
        case ROUTES.PRICEBOOK_NEW:
        case ROUTES.PRICEBOOK_ENTRY_NEW:
        case ROUTES.NOTE_NEW:
        case ROUTES.PROMO_CODE_NEW:
        case ROUTES.PROMO_CODE_FAMILY_NEW:
        case ROUTES.PROMO_CODE_TYPE_NEW:
        case ROUTES.PRODUCT_TO_PROMOCODE_NEW:
        case ROUTES.PACKAGE_TO_PROMOCODE_NEW:
        case ROUTES.PRODUCT_TO_PACKAGE_NEW:
        case ROUTES.REFERRAL_NEW:
        case ROUTES.RENEWAL_NEW:
        case ROUTES.PRODUCT_TO_CONTRACT_NEW:
            import('../components/htPandoraNewItem.js')
            break
        case ROUTES.CONTROLLER:
            prepareSelectedItem(dispatch, pageBase, -1)
            import('../components/htPandoraItem.js')
            break
        case ROUTES.PRODUCT:
        case ROUTES.PRODUCT_PACKAGE:
        case ROUTES.PROPERTY:
        case ROUTES.ACCOUNT:
        case ROUTES.CONTRACT:
        case ROUTES.ACCOUNT_TO_PROPERTY:
        case ROUTES.PRICEBOOK:
        case ROUTES.PRICEBOOK_ENTRY:
        case ROUTES.NOTE:
        case ROUTES.PROMO_CODE:
        case ROUTES.PROMO_CODE_FAMILY:
        case ROUTES.PROMO_CODE_TYPE:
        case ROUTES.PRODUCT_TO_PROMOCODE:
        case ROUTES.PACKAGE_TO_PROMOCODE:
        case ROUTES.PRODUCT_TO_PACKAGE:
        case ROUTES.REFERRAL:
        case ROUTES.RENEWAL:
        case ROUTES.PRODUCT_TO_CONTRACT:
            const selectedItemValue = isNaN(pageParam) ? 0 : parseInt(pageParam, 10)
            prepareSelectedItem(dispatch, pageBase, selectedItemValue)
            import('../components/htPandoraItem.js')
            break
        case ROUTES.ANALYTICS:
            import('../components/htPandoraAnalytics.js')
            break
        default:
            pageBase = ROUTES.NOT_FOUND
            import('../components/htPandora404.js')
    }

    pageSelected = pageBase

    dispatch(updatePage(pageSelected))
}

const prepareSelectedItem = (dispatch, item, selectedItemValue) => {
    dispatch({
        type: UPDATE_SELECTED_ITEM,
        item,
        value: selectedItemValue,
    })
}

const updatePage = (page) => ({
    type: UPDATE_PAGE,
    page,
})

export const addNotification = (notification) => (dispatch) => {
    dispatch({
        type: ADD_NOTIFICATION,
        notification,
    })
}

export const removeNotification = (index) => (dispatch) => {
    dispatch({
        type: REMOVE_NOTIFICATION,
        index,
    })
}

export const setNotifications = (notifications) => (dispatch) => {
    dispatch({
        type: SET_NOTIFICATIONS,
        notifications,
    })
}

let snackbarTimer

export const showSnackbar = () => (dispatch) => {
    dispatch({
        type: OPEN_SNACKBAR,
    })
    window.clearTimeout(snackbarTimer)
    snackbarTimer = window.setTimeout(() => dispatch({ type: CLOSE_SNACKBAR }), 3000)
}

export const updateOffline = (offline) => (dispatch, getState) => {
    // Show the snackbar only if offline status changes.
    if (offline !== getState().app.offline) {
        dispatch(showSnackbar())
    }
    dispatch({
        type: UPDATE_OFFLINE,
        offline,
    })
}

export const updateDrawerState = (opened) => ({
    type: UPDATE_DRAWER_STATE,
    opened,
})

const getOptionFieldRequest = (dispatch, getData, action, key, route = null) => {
    const getItemData = getData(action)

    getItemData
        .then((response) => response.json())
        .then((data) => {
            if (data.errorMessage) {
                console.log('failed to retrieve contract status options 1', data)
            } else if (!data.data[0]) {
                console.log('failed to retrieve contract status options 2', data)
            } else {
                const newOptionObject = {}
                newOptionObject[key] = data.data
                    .sort((a, b) => {
                        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                    })
                    .map((item) => {
                        item.route = route
                        return item
                    })
                dispatch(updateOptionFields(newOptionObject))
            }
        })
        .catch((error) => {
            console.log('failed to retrieve contract status options 3', error)
        })
}

export const getOptionField = (fieldKey) => (dispatch) => {
    switch (fieldKey) {
        case 'contract_status':
            getOptionFieldRequest(dispatch, getDataContract, '/status', fieldKey)
            break
        case 'contract_type':
            getOptionFieldRequest(dispatch, getDataContract, '/types', fieldKey)
            break
        case 'renewal_status':
            getOptionFieldRequest(dispatch, getDataRenewal, '/status', fieldKey)
            break
        case 'contract_billing':
            getOptionFieldRequest(dispatch, getDataContract, '/billingtypes', fieldKey)
            break
        case 'package':
            getOptionFieldRequest(dispatch, getDataPackage, '', fieldKey, ROUTES.PRODUCT_PACKAGE)
            break
        case 'cancellation_type':
            getOptionFieldRequest(dispatch, getDataContract, '/cancellationtypes', fieldKey)
            break
        case 'cancellation_status':
            getOptionFieldRequest(dispatch, getDataContract, '/cancellationstatus', fieldKey)
            break
        case 'property_type':
            getOptionFieldRequest(dispatch, getDataProperty, '/types', fieldKey)
            break
        case 'property_fueltype':
            getOptionFieldRequest(dispatch, getDataProperty, '/fuelTypes', fieldKey)
            break
        case 'property_fluepositions':
            getOptionFieldRequest(dispatch, getDataProperty, '/fluePositions', fieldKey)
            break
        case 'account_to_property_relation':
            getOptionFieldRequest(dispatch, getDataAccount, '/relationtypes', fieldKey)
            break
        case 'promocode_family':
            getOptionFieldRequest(dispatch, getDataPromocode, '/families', fieldKey)
            break
        case 'promocode_type':
            getOptionFieldRequest(dispatch, getDataPromocode, '/types', fieldKey)
            break
        default:
            break
    }

    const newOptionObject = {}
    newOptionObject[fieldKey] = 'pending'
    dispatch(updateOptionFields(newOptionObject))
}

const updateOptionFields = (fieldOptions) => ({
    type: ADD_FIELD_OPTION,
    fieldOptions,
})

export const changeHiddenOption = (tableType, columns) => (dispatch) => {
    dispatch({
        type: CHANGE_HIDDEN_COLUMNS,
        tableType,
        columns,
    })
}

export const changeTableActiveFlag = (tableType, flag) => (dispatch) => {
    dispatch({
        type: CHANGE_TABLE_ACTIVE_FLAG,
        tableType,
        flag,
    })
}

export const addRelationClone = (relationClone) => (dispatch) => {
    dispatch({
        type: ADD_RELATION_CLONE,
        relationClone,
    })
}

export const login = (user) => (dispatch) => {
    dispatch({
        type: LOGIN,
        user,
    })
}

export const logout = () => (dispatch) => {
    dispatch({
        type: LOGOUT,
    })
}

export const addWarningItem = (warningItem) => (dispatch) => {
    dispatch({
        type: ADD_WARNING_ITEM,
        warningItem,
    })
}

export const removeWarningItem = (table, warningType) => (dispatch) => {
    dispatch({
        type: REMOVE_WARNING_ITEM,
        table,
        warningType,
    })
}

export const addEditableItem = (item, table, action) => (dispatch) => {
    dispatch({
        type: ADD_EDITABLE_ITEM,
        editableItem: { item, table, action },
    })
}

export const removeEditableItem = () => (dispatch) => {
    dispatch({
        type: REMOVE_EDITABLE_ITEM,
    })
}

export const addEditableRenewal = (renewal) => (dispatch) => {
    dispatch({
        type: ADD_EDITABLE_RENEWAL,
        editableRenewal: renewal,
    })
}

export const removeEditableRenewal = () => (dispatch) => {
    dispatch({
        type: REMOVE_EDITABLE_RENEWAL,
    })
}

export const updateList = (list, table) => (dispatch) => {
    dispatch({
        type: UPDATE_LIST,
        list,
        table,
    })
}

export const updateItemInList = (itemId, item, table) => (dispatch) => {
    dispatch({
        type: UPDATE_ITEM_IN_LIST,
        itemId,
        item,
        table,
    })
}
